<div class="shadow-md">
<cm-app-header-ri
  [customUserActions]="customUserActions"
  (logout)="onLogout()"

 >
  <ng-content navbarEnd select="[navbarEnd]">
    <div
    style="font-size: 0.8rem;"
    class="text-section-header inline-block content-center justify-self-end w-60 h-10 text-center">
    <div class="inline-block w-1/4">
      <i class="pi pi-trophy" style="font-size: 2rem"></i>
      <mat-icon  fontSet="material-symbols-outlined" style="position: relative; top: 4px; left: 2px; font-size: 2rem;">trophy</mat-icon>
    </div>
    <div class="inline-block w-3/4 text-left" style="position: relative; top: 6px; line-height: 0.75rem;">
      <span style="font-size: 1.2rem">{{ metrics()?.completedTasksCount || '-' }}</span>
      <br/>
      tasks completed<br/>
      today
    </div>
  </div>
  </ng-content>
  <ng-content userActionFooter select="[userActionFooter]"></ng-content>

</cm-app-header-ri>
</div>
